module.exports = __webpack_public_path__ + "static/media/ic_searchtype_shipyard.76005f3e.svg";